export function TrashCard({ onClick, disabled, children }) {
  return (
    <button
      className="group relative flex items-center justify-between w-full min-h-12.5 p-2.5 border border-300 rounded-lg bg-white shadow-sm font-normal text-body-dark hover:text-body-dark transition-colors disabled:opacity-50 hover:enabled:bg-error-50 hover:enabled:border-error-500"
      onClick={onClick}
      // onKeyDown={(e) => {
      //   if (e.key === 'Enter' || e.key === ' ') {
      //     e.preventDefault();
      //     onClick?.(e);
      //   }
      // }}
      disabled={disabled}
      tabIndex={0}
      type="button"
    >
      <div className="flex items-center gap-2.5">{children}</div>
      <div className="size-11 flex items-center justify-center" aria-hidden="true">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="stroke-gray-500 transition-colors group-hover:stroke-error"
        >
          <path
            d="M19 7L18.1327 19.1425C18.0579 20.1891 17.187 21 16.1378 21H7.86224C6.81296 21 5.94208 20.1891 5.86732 19.1425L5 7M10 11V17M14 11V17M15 7V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V7M4 7H20"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </button>
  );
}
